module.exports = __webpack_public_path__ + "img/profession2.7eb11d8c.png";